import React from "react";
import { EntityEditProvider } from "@/contexts/EntityEditContext";
import type { EntityEditProviderProps } from "@/types/contexts/entityEdit";
import { CourseType } from "@/types/db/courses";
import { courseService } from "@/services/courseService";

interface CourseEditProviderProps extends Omit<EntityEditProviderProps<CourseType>, "onSave" | "entityName"> {
  children: React.ReactNode;
}

export function CourseEditProvider({ children, entityData, loading, onSaveSuccess }: CourseEditProviderProps) {
  const handleSave = async (formData: Partial<CourseType>): Promise<CourseType> => {
    if (!entityData?.id) {
      throw new Error("No course ID available");
    }

    // Clean the data - remove read-only fields before sending to database
    const { id, created_at, tenant_id, ...cleanFormData } = formData;

    const updatedCourse = await courseService.updateCourse(entityData.id, cleanFormData);
    return updatedCourse;
  };

  return (
    <EntityEditProvider
      entityData={entityData}
      loading={loading}
      onSave={handleSave}
      onSaveSuccess={onSaveSuccess}
      entityName="Course"
    >
      {children}
    </EntityEditProvider>
  );
}
